import template from './states-template.html';
import controller from './states-template.controller';

let statesTemplateComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default statesTemplateComponent;
